import type { TableActionSpec } from '@/@vxapp/@Types/ServiceMetadata'

export const ContractsTableActions = [
  {
    id: 'edit',
    title: 'Edit Contract',
    icon: 'tabler-pencil',
    color: 'primary',
    emit: 'edit',
  },
  {
    id: 'view',
    title: 'View Contract',
    icon: 'tabler-eye',
    color: 'primary',
    emit: 'view',
  },
] as const satisfies readonly TableActionSpec[]
